import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'loader-ellipsis',
    imports: [CommonModule],
    templateUrl: './ellipsis.component.html',
    styleUrl: './ellipsis.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderEllipsisComponent {}
